import { useEffect, useState } from "react";
import styles from "./receiveShipping.module.css";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField, Table, TableHead, TableContainer, Paper, TableBody, TableRow, Breadcrumbs, Typography, Checkbox, Snackbar, Alert } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useNavigate } from "react-router";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { authData, withAdminAuth } from "../../components/GetAuth";
import Loader from "../../components/Loader";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { StyledMainTableCell } from "../../components/TableComponent";
import { Calendar, Search } from "react-feather";
import { DateRangePicker } from "rsuite";
import GHWHItemListCustomRow from "./components/GHWHItemListCustomRow";
import ConItemListCustomRowGH from "./components/ConItemListCustomRowGH";

const DeliveryReceiveShipping = ({ history, match }) => {
  const auth = authData();
  const navigate = useNavigate();
  const [containerList, setContainerList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [WHItems, setWHItems] = useState([]);
  const [WHFilterItems, setWHFilterItems] = useState([]);
  const [containerItems, setContainerItems] = useState([]);
  const [containerFilterItems, setContainerFilterItems] = useState([]);
  const [shippingData, setShippingData] = useState(null);
  const [shippingId, setShippingId] = useState(0);
  const [filterVars1, setFilterVars1] = useState({ searchKey: "", date: null });
  const [filterVars2, setFilterVars2] = useState({ searchKey: "", date: null });
  const [selected1, setSelected1] = useState([]);
  const [selected2, setSelected2] = useState([]);
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMsg, setSnackMsg] = useState('Please select container first!!');

  const { register, control, setValue } = useForm({
    mode: "onChange",
    defaultValues: {
      container_no: "",
      shipping_from: "",
      shipping_to: "",
      consignee: "",
      warehouse_location: "",
    }
  });

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/delivery/shipping-dd-list", {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setContainerList(response.data.data);
      }
    });
  }, [auth?.api_token]);

  useEffect(() => {
    if (shippingId) {
      axios.get(process.env.REACT_APP_API_URL + "v1/delivery/shipping-details/" + shippingId, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") {
          let shipData = response.data.data;
          setShippingData(shipData);
          setValue("reference_id", shipData.reference_id);
          setValue("container_ref", shipData.container_ref);
          setValue("shipping_from", shipData.shipping_from);
          setValue("shipping_to", shipData.shipping_to);
          setValue("shipping_date", dayjs(shipData.shipping_date));
          setValue("eta_of_container", dayjs(shipData.eta_of_container));
          setValue("arrival_date", shipData?.arrival_date ? dayjs(shipData?.arrival_date) : dayjs());
          setValue("consignee", shipData.consignee);
          setValue("warehouse_location", shipData?.warehouse_location);
        }
      });
    }
  }, [shippingId, setValue, auth?.api_token]);

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-ghwh", {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setWHItems(response.data.data);
      }
    });
  }, [auth?.api_token]);

  useEffect(() => {
    if (shippingId && (shippingData?.status === 2 || shippingData?.status === "2")) {
      axios.get(process.env.REACT_APP_API_URL + "v1/delivery/booking-list-ship/" + shippingId, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then((response) => {
        if (response.data.status === "SUCCESS") {
          setContainerItems(response.data.data);
        }
      });
    } else {
      setContainerItems([]);
    }
  }, [shippingId, shippingData, auth?.api_token]);

  const cngContainer = (e) => {
    setShippingId(e?.target?.value);
  }

  const receiveContainer = () => {
    if (shippingId === 0) {
      return false;
    }
    setLoading(true);

    axios.get(process.env.REACT_APP_API_URL + "v1/delivery/shipping-received/" + shippingId, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        navigate(0);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  const receiveItemNew = (item_ids) => {
    let data = { shpping_id: shippingId, item_ids: item_ids };
    axios.post(process.env.REACT_APP_API_URL + "v1/delivery/item-received-new", data, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-ghwh", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setWHItems(response.data.data);
          }
        });

        if (shippingId) {
          axios.get(process.env.REACT_APP_API_URL + "v1/delivery/booking-list-ship/" + shippingId, {
            headers: {
              Authorization: `Bearer ${auth?.api_token}`,
            }
          }).then((response) => {
            if (response.data.status === "SUCCESS") {
              setContainerItems(response.data.data);
            }
          });
        }
      }
    });
  }

  useEffect(() => {
    let WHItemsTemp = WHItems;
    if (filterVars1?.searchKey !== "") {
      let inputVal = filterVars1?.searchKey;
      inputVal = inputVal.toLowerCase();
      WHItemsTemp = WHItemsTemp.filter((item) => { return item?.booking_id.toLowerCase().includes(inputVal); });
    }

    if (filterVars1?.date) {
      WHItemsTemp = WHItemsTemp.filter((i) => dayjs(i?.pickup_date).isBetween(dayjs(filterVars1?.date[0]).format("YYYY-MM-DD"), dayjs(filterVars1?.date[1]).format("YYYY-MM-DD"), "day", "[]"));
    }

    setWHFilterItems(WHItemsTemp);
  }, [filterVars1, WHItems]);

  useEffect(() => {
    let containerItemsTemp = containerItems;

    if (filterVars2?.searchKey !== "") {
      let inputVal = filterVars2?.searchKey;
      inputVal = inputVal.toLowerCase();
      containerItemsTemp = containerItemsTemp.filter((item) => { return item.booking_id.toLowerCase().includes(inputVal); });
    }

    if (filterVars2?.date) {
      containerItemsTemp = containerItemsTemp.filter((i) => dayjs(i?.pickup_date).isBetween(dayjs(filterVars2?.date[0]).format("YYYY-MM-DD"), dayjs(filterVars2?.date[1]).format("YYYY-MM-DD"), "day", "[]"));
    }

    setContainerFilterItems(containerItemsTemp);
  }, [filterVars2, containerItems]);

  const selectRowEvent1 = (id) => {
    const selectedIndex = selected1.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected1, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected1.slice(1));
    } else if (selectedIndex === selected1.length - 1) {
      newSelected = newSelected.concat(selected1.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected1.slice(0, selectedIndex), selected1.slice(selectedIndex + 1));
    }
    setSelected1(newSelected);
  }

  const selectRowEvent2 = (id) => {
    const selectedIndex = selected2.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected2, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected2.slice(1));
    } else if (selectedIndex === selected1.length - 1) {
      newSelected = newSelected.concat(selected2.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected2.slice(0, selectedIndex), selected2.slice(selectedIndex + 1));
    }
    setSelected2(newSelected);
  }

  const receiveSelectedItemNew = () => {
    if (selected2.length === 0) {
      setSnackMsg('Please select booking first!!');
      setSnackOpen(true);
      return false;
    }

    let availableIds = [];

    containerFilterItems?.forEach(item => {
      item?.products?.forEach(pItem => {
        if (pItem?.container_id === shippingData?.container_no) {
          availableIds.push(pItem?.id);
        }
      })
    });

    if (availableIds?.length > 0) {
      receiveItemNew(availableIds);
    }
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen(false);
  }

  const removeItemNew = (item_ids) => {
    let data = { item_ids: item_ids };
    axios.post(process.env.REACT_APP_API_URL + "v1/delivery/item-removed-new", data, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios.get(process.env.REACT_APP_API_URL + "v1/shippings/booking-list-ghwh", {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setWHItems(response.data.data);
          }
        });

        if (shippingId) {
          axios.get(process.env.REACT_APP_API_URL + "v1/delivery/booking-list-ship/" + shippingId, {
            headers: {
              Authorization: `Bearer ${auth?.api_token}`,
            }
          }).then((response) => {
            if (response.data.status === "SUCCESS") {
              setContainerItems(response.data.data);
            }
          });
        }
      }
    });
  }

  return (<>
    {loading && <Loader />}
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>Receive Shipping</p>
        <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
          <Typography color="text.primary">Delivery</Typography>
          <Typography color="text.primary">Receive Shipping</Typography>
        </Breadcrumbs>
      </div>

      <div className={`${styles.MainCard}`}>
        <div className={`${styles.StepOneForm}`}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div style={{ display: "flex", flexWrap: "nowrap", justifyContent: "space-between" }}>
              <div className={`FormHalfGroup`} style={{ width: '50%', marginLeft: 0 }}>
                <div className={`${styles.FieldWrap}`}>
                  <FormControl fullWidth>
                    <InputLabel>Container*</InputLabel>
                    <Controller
                      control={control}
                      {...register("container_no")}
                      render={({ field }) => (<Select
                        label="Container*"
                        {...field}
                        onChange={(e) => {
                          field.onChange(e);
                          cngContainer(e);
                        }}
                      >
                        {containerList?.map((val) => {
                          return (<MenuItem key={val?.value} value={val?.value}>{val?.label}</MenuItem>);
                        })}
                      </Select>)}
                    />
                  </FormControl>
                </div>
              </div>
              <div className={`FormHalfGroup`} style={{ width: '25%' }}>
                <Controller
                  control={control}
                  disabled
                  {...register("shipping_from")}
                  render={({ field }) => (<TextField {...field} label="Shipping From*" variant="outlined" />)}
                />
              </div>
              <div className={`FormHalfGroup`} style={{ width: '25%' }}>
                <Controller
                  control={control}
                  disabled
                  {...register("shipping_to")}
                  render={({ field }) => (<TextField {...field} label="Shipping To*" variant="outlined" />)}
                />
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "nowrap", justifyContent: "space-between" }}>
              <div className={`FormHalfGroup`} style={{ width: '25%', marginLeft: 0 }}>
                <Controller
                  control={control}
                  disabled
                  {...register("shipping_date")}
                  render={({ field }) => (<DatePicker {...field} minDate={dayjs()} label="Shipping Date" />)}
                />
              </div>
              <div className={`FormHalfGroup`} style={{ width: '25%' }}>
                <Controller
                  control={control}
                  disabled
                  {...register("eta_of_container")}
                  render={({ field }) => (<DatePicker {...field} minDate={dayjs()} label="Eta Of Container" />)}
                />
              </div>
              <div className={`FormHalfGroup`} style={{ width: '25%' }}>
                <Controller
                  control={control}
                  disabled
                  {...register("consignee")}
                  render={({ field }) => (<TextField {...field} label="Consignee*" variant="outlined" />)}
                />
              </div>
              <div className={`FormHalfGroup`} style={{ width: '25%' }}>
                <Controller
                  control={control}
                  disabled
                  {...register("warehouse_location")}
                  render={({ field }) => (<TextField {...field} label="Warehouse Location*" ariant="outlined" />)}
                />
              </div>
            </div>

            <div className={`${styles.StepBUSec}`}>
              {(shippingData?.status === 1 || shippingData?.status === "1") && (<button className={`${styles.Next} ${styles.Next11}`} type="button" onClick={receiveContainer} style={{ width: '210px' }}>Mark Container as Received</button>)}
              {(shippingData?.status === 2 || shippingData?.status === "2") && (<button className={`${styles.Next} ${styles.Next33}`} disabled type="button">Container Received</button>)}
            </div>
          </LocalizationProvider>
        </div>
      </div>

      <div className={`${styles.MainCard}`} style={{ background: 'none', padding: 0 }}>
        <div className={`${styles.MainCard2Half} ${styles.MainCard2Half1}`}>
          <p>Container Details</p>
          <div className="TableFilterHead" style={{ margin: '20px 0' }}>
            <div className="DataTableSearch WithFilter">
              <Search className="SearchIcon" />
              <TextField type="text" placeholder="Search" value={filterVars2?.searchKey} onChange={(e) => setFilterVars2((prev) => { return { ...prev, searchKey: e.target.value }; })} />
              {filterVars2?.searchKey !== "" && (<Button type="button" className="CloseBU" onClick={(e) => setFilterVars2((prev) => { return { ...prev, searchKey: "" }; })}><Close /></Button>)}
            </div>
            <div className="TableFilterBUSec">
              <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                <div className={`${styles.DashFilterSec} DashFilterSec`}>
                  <DateRangePicker format={"dd/MM/yyyy"} placement={"bottomEnd"} placeholder="Serach by date" caretAs={Calendar} value={filterVars2?.date} showOneCalendar onChange={(e) => setFilterVars2((prev) => { return { ...prev, date: e }; })} />
                </div>
              </div>
              <div className={`${styles.FilterCard} Filter`}>
                <div className={`${styles.DashFilterSec} DashFilterSec`}>
                  <div className={`${styles.FilerButton}`}>
                    <Button className="TableAddBUName" disabled={!(shippingId && (shippingData?.status === 2 || shippingData?.status === "2"))} onClick={(e) => receiveSelectedItemNew()}>Receive All</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="CusTable">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell padding="checkbox">
                      <Checkbox
                        className="AllCheckbox"
                        color="primary"
                        indeterminate={selected2?.length > 0 && selected2?.length < containerFilterItems?.length}
                        checked={containerFilterItems?.length > 0 && selected2?.length === containerFilterItems?.length}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const newSelected = containerFilterItems.map((n) => n.id);
                            setSelected2(newSelected);
                            return;
                          }
                          setSelected2([]);
                        }}
                        disabled={shippingData?.status === 1 || shippingData?.status === "1"}
                      />
                    </StyledMainTableCell>
                    <StyledMainTableCell>Booking Id</StyledMainTableCell>
                    <StyledMainTableCell>Pickup Date</StyledMainTableCell>
                    <StyledMainTableCell>Items</StyledMainTableCell>
                    <StyledMainTableCell>Loaded</StyledMainTableCell>
                    <StyledMainTableCell>Remaining</StyledMainTableCell>
                    <StyledMainTableCell></StyledMainTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {containerFilterItems?.map((item) => {
                    const isItemSelected = selected2.indexOf(item?.id) !== -1;
                    return (<ConItemListCustomRowGH item={item} isItemSelected={isItemSelected} shippingData={shippingData} selectRowEvent={selectRowEvent2.bind(this)} receiveItemNew={receiveItemNew.bind(this)} />);
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>

        <div className={`${styles.MainCard2Half}  ${styles.MainCard2Half2}`}>
          <p>Item In GH Warehouse</p>
          <div className="TableFilterHead" style={{ margin: '20px 0' }}>
            <div className="DataTableSearch WithFilter">
              <Search className="SearchIcon" />
              <TextField type="text" placeholder="Search" value={filterVars1?.searchKey} onChange={(e) => setFilterVars1((prev) => { return { ...prev, searchKey: e.target.value }; })} />
              {filterVars1?.searchKey !== "" && (<Button type="button" className="CloseBU" onClick={(e) => setFilterVars1((prev) => { return { ...prev, searchKey: "" }; })}><Close /></Button>)}
            </div>
            <div className="TableFilterBUSec">
              <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
                <div className={`${styles.DashFilterSec} DashFilterSec`}>
                  <DateRangePicker format={"dd/MM/yyyy"} placement={"bottomEnd"} placeholder="Serach by date" caretAs={Calendar} value={filterVars1?.date} showOneCalendar onChange={(e) => setFilterVars1((prev) => { return { ...prev, date: e }; })} />
                </div>
              </div>
              <div className={`${styles.FilterCard} Filter`}>
                <div className={`${styles.DashFilterSec} DashFilterSec`}>
                  <div className={`${styles.FilerButton}`}>
                    <Button className="TableAddBUName">Remove All</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="CusTable">
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell padding="checkbox">
                      <Checkbox
                        disabled
                        className="AllCheckbox"
                        color="primary"
                        indeterminate={selected1?.length > 0 && selected1?.length < WHFilterItems?.length}
                        checked={WHFilterItems?.length > 0 && selected1?.length === WHFilterItems?.length}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const newSelected = WHFilterItems.map((n) => n.id);
                            setSelected1(newSelected);
                            return;
                          }
                          setSelected1([]);
                        }}
                      />
                    </StyledMainTableCell>
                    <StyledMainTableCell>Booking Id</StyledMainTableCell>
                    <StyledMainTableCell>Pickup Date</StyledMainTableCell>
                    <StyledMainTableCell>Items</StyledMainTableCell>
                    <StyledMainTableCell>Received</StyledMainTableCell>
                    <StyledMainTableCell>Remaining</StyledMainTableCell>
                    <StyledMainTableCell></StyledMainTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {WHFilterItems?.map((item) => {
                    const isItemSelected = selected1.indexOf(item?.id) !== -1;
                    return (<GHWHItemListCustomRow item={item} isItemSelected={isItemSelected} selectRowEvent={selectRowEvent1.bind(this)} removeItemNew={removeItemNew.bind(this)} shippingData={shippingData} />);
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>

    <Snackbar open={snackOpen} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "right" }} autoHideDuration={3000}>
      <Alert onClose={handleClose} severity="warning" variant="filled" sx={{ width: "100%" }}>{snackMsg}</Alert>
    </Snackbar>
  </>);
};

export default withAdminAuth(DeliveryReceiveShipping);